import { getScoreAction } from 'affiny-core/modules/scores/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useDispatchGetScore = (accountId: string) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getScoreAction(accountId));
  }, []);
};
